import { apiFetch } from './api';

export async function trackUxEvent(name, metadata = {}) {
  if (!name) return;
  try {
    await apiFetch('/ux-events', {
      method: 'POST',
      body: JSON.stringify({ name, metadata })
    });
  } catch (error) {
    // Fire-and-forget telemetry should not block user workflows.
    console.debug('Telemetry event failed', { name, error });
  }
}
